/** @format */
import React, { useEffect, useState } from 'react';
import { SilverBackground } from './silverBackground';
import { ContentBlock } from './contentBlock';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'src/store';
import { Header } from 'src/components/header/header';
import { Footer } from 'src/components/footer/footer';
import { getPublicContentInfo, getPrivateContentInfo, getFooterLinksInfo } from 'src/slices/global';
import { Redirect } from 'react-router';
import i18n from '../../i18n';
import { setPersistedAcceptLanguage } from 'src/utils/acceptLanguage';
import useAuth from 'src/hooks/useAuth';
import Breadcrumb from 'src/components/Breadcrumb';
import GlobalHeader from 'src/components/globalHeader';
import LoadingScreen from 'src/components/LoadingScreen';

const getLanguage = () => i18n.language || 'en';

const LegalLayout = () => {
  const { user } = useAuth();
  const { pageId, type } = useParams();
  const dispatch = useDispatch();
  const [contentInfo, setContentInfo] = useState({});
  const [userLang, setUserLang] = useState(getLanguage());
  const { error, globalLoading } = useSelector(state => state.global);

  useEffect(() => {
    i18n.changeLanguage(userLang);
  }, [userLang]);

  useEffect(() => {
    if (!pageId || type !== 'public') return;
    dispatch(getPublicContentInfo(pageId, setContentInfo, () => {}));
    if (!user) {
      dispatch(getFooterLinksInfo());
    }
  }, [pageId, userLang, type, user, dispatch]);

  useEffect(() => {
    if (!pageId || type === 'public') return;
    dispatch(getPrivateContentInfo(pageId, setContentInfo, () => {}));
  }, [pageId, userLang, type, dispatch]);

  const handleLangChange = e => {
    const newLang = e.target.value;
    setPersistedAcceptLanguage(newLang);
    setUserLang(newLang);
  };

  return error ? (
    <Redirect to="/404" />
  ) : (
    <section className="main_section legalPage">
      {/* <Header getSelectLang={handleLangChange} userLang={userLang} /> */}
      {globalLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <Breadcrumb data={[{ title: contentInfo?.title }]} additionClassName="container-narrow" />
          <div className="container container-narrow">
            <h1 className="page_title">{contentInfo?.title || ''}</h1>
            <ContentBlock content={contentInfo} />
          </div>
        </>
      )}
      {/* <Footer /> */}
    </section>
  );
};

export { LegalLayout };
